import { getCookie } from '@frontend/cookie';

const cookieName = 'siteName';

const inferChannelSlugFromCookieValue = (cookieValue: string): string | undefined => {
  const normalized = cookieValue.toLowerCase();

  if (normalized === 'edge' || normalized.includes('edge.')) {
    return 'edge';
  }

  if (normalized === 'stable' || normalized.includes('app.')) {
    return 'stable';
  }

  return undefined;
};

/**
 * Reads the deploy channel slug directly from the channel cookie.
 * Used for Sentry event tagging. For full channel config lookup, use
 * `getCurrentChannelSlug` from `@frontend/automatic-updates`.
 */
export const getCurrentChannelSlug = (): string | undefined => {
  const cookieChannel = getCookie(cookieName);
  if (!cookieChannel) {
    return undefined;
  }

  return inferChannelSlugFromCookieValue(cookieChannel);
};
